import { render, staticRenderFns } from "./PathwayDetail.vue?vue&type=template&id=a9087d0c&scoped=true"
import script from "./PathwayDetail.vue?vue&type=script&lang=js"
export * from "./PathwayDetail.vue?vue&type=script&lang=js"
import style0 from "./PathwayDetail.vue?vue&type=style&index=0&id=a9087d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9087d0c",
  null
  
)

export default component.exports